export const NESTED_TRACKS_TOGGLE = 'NestedTracks'
export const NESTED_TRACKS_TRAY_ID = 'nested-tracks-tray'
export const NESTED_TRACKS_TRAY_SCROLL_CONTAINER_SELECTOR =
	'[data-nested-tracks-tray-scroll]'
